<div class="blog-wrapper">
  <div class="content-wrapper">
    <!-- content-header component -->
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="content-detached" *blockUI="'section-block'">
      <div class="content-body">
        <!-- Blog Detail -->
        <div class="blog-detail-wrapper">
          <div class="row">
            <div class="col-12">
              <div class="card shadow-none">
                <div class="card-body" *ngIf="isReadonly">
                  <!-- <div class="badge badge-pill badge-warning" *ngIf="!data.isConfirmed">
                    Doğrulanmamış  
                  </div> -->

                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <h4 class="card-title mb-0">{{data.companyName}}</h4>
                    <img [src]="data.companyFile" alt="resim yok" width="80px" height="80px" *ngIf="data.companyFile"
                      style="margin-left: 10px;">
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="info-row" *ngIf="data.mail">
                        <p class="card-text mb-1">
                          <i data-feather="mail" class="mr-1"></i> {{data.mail}}
                        </p>
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="info-row" *ngIf="data.phoneNumber">
                        <p class="card-text mb-1">
                          <i data-feather="phone" class="mr-1"></i> {{formatPhoneNumber(data.phoneNumber)}}
                          {{formatPhoneNumber(data.phoneNumber2)}}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <div class="info-row" *ngIf="data.taxAdministration">
                        <p class="card-text mb-1">
                          <i class="mr-1" data-feather="book-open"></i> {{data.taxAdministration}} / {{data.taxNumber}}
                        </p>
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="info-row" *ngIf="data.address">
                        <p class="card-text mb-1">
                          <i data-feather="home" class="mr-1"></i> {{data.address}}
                        </p>
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="card-text mt-1" *ngIf="data.label">
                        <div class="badge badge-pill badge-primary" *ngFor="let label of data.label">
                          <i data-feather="tag" class="mr-1"></i> {{label.labelName}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-end ml-1" *ngIf="isReadonly">
                  <button type="button" class="btn btn-icon btn-warning" (click)="toggleReadonly()" rippleEffect>
                    <span [data-feather]="'edit'"></span>
                  </button>
                </div>

              </div>

              <div class="card shadow-none" *ngIf="!isReadonly">
                <div class="card-body">
                  <div class="row">
                    <div class="col-xl-4 col-md-8 col-12">
                      <div class="form-group">
                        <label for="companyName">Şirket Adı</label>
                        <input type="text" class="form-control" id="companyName"
                          [attr.readonly]="isReadonly ? true : null" [(ngModel)]="data.companyName"
                          (ngModelChange)="data.companyName = $event.toUpperCase()" />
                      </div>
                    </div>
                    <div class="col-xl-2 col-md-6 col-12">
                      <div class="form-group">
                        <label for="taxNumber">Vergi Numarası</label>
                        <input type="text" class="form-control" id="taxNumber"
                          [attr.readonly]="isReadonly ? true : null" [(ngModel)]="data.taxNumber" maxlength="11" />
                      </div>
                    </div>
                    <div class="col-xl-2 col-md-6 col-12">
                      <div class="form-group">
                        <label for="taxAdministration">Vergi Dairesi</label>
                        <input type="text" class="form-control" id="taxAdministration"
                          [attr.readonly]="isReadonly ? true : null" [(ngModel)]="data.taxAdministration"
                          oninput="this.value = this.value.toUpperCase()" />
                      </div>
                    </div>
                    <div class="col-xl-2 col-md-6 col-12">
                      <div class="form-group">
                        <label for="discountRate">İndirim Oranı</label>
                        <input type="number" class="form-control" id="discountRate"
                          [attr.readonly]="isReadonly ? true : null" [(ngModel)]="data.discountRate" maxlength="2"
                          onKeyUp="if(this.value>99){this.value='99';}else if(this.value<0){this.value='0';}" />
                      </div>
                    </div>
                    <div class="col-xl-2 col-md-6 col-12">
                      <div class="form-group">
                        <label for="futuresDay">Vade Gün</label>
                        <input type="number" class="form-control" id="futuresDay"
                          [attr.readonly]="isReadonly ? true : null" [(ngModel)]="data.futuresDay"
                          onKeyUp="if(this.value>99){this.value='99';}else if(this.value<0){this.value='0';}" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-xl-4 col-md-6 col-12">
                      <div class="form-group" *ngIf="isReadonly">
                        <label for="activityArea">Kategori</label>
                        <input type="text" class="form-control" id="activityArea"
                          [attr.readonly]="isReadonly ? true : null" [(ngModel)]="data.categoryName" />
                      </div>
                      <div class="form-group" *ngIf="!isReadonly">
                        <label for="activityArea">Kategori</label>
                        <select class="form-control" id="currency" *ngIf="!isReadonly" [(ngModel)]="data.categoryId">
                          <option *ngFor="let item of itemCategory" [value]="item.id"
                            [selected]="data.categoryId == item.id">
                            {{item.categoryName}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-xl-4 col-md-6 col-12">
                      <div class="form-group">
                        <label for="email">Email</label>
                        <input type="text" class="form-control" id="email" [attr.readonly]="isReadonly ? true : null"
                          [(ngModel)]="data.mail" />
                      </div>
                    </div>
                    <div class="col-xl-2 col-md-6 col-12">
                      <div class="form-group">
                        <label for="phoneNumber">Telefon No</label>
                        <input type="text" class="form-control" id="phoneNumber"
                          [attr.readonly]="isReadonly ? true : null" [(ngModel)]="data.phoneNumber"
                          mask="(000) 000 00 00" />
                      </div>
                    </div>
                    <div class="col-xl-2 col-md-6 col-12">
                      <div class="form-group">
                        <label for="phoneNumber2">Telefon No 2</label>
                        <input type="text" class="form-control" id="phoneNumber2"
                          [attr.readonly]="isReadonly ? true : null" [(ngModel)]="data.phoneNumber2"
                          mask="(000) 000 00 00" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-xl-8 col-md-8 col-12">
                      <div class="form-group">
                        <label for="address">Adres</label>
                        <input type="text" class="form-control" tabindex="2" id="address"
                          oninput="this.value = this.value.toUpperCase()" [attr.readonly]="isReadonly ? true : null"
                          [(ngModel)]="data.address" />
                      </div>
                    </div>

                    <div class="col-xl-4 col-md-4 col-12">
                      <div class="form-group">
                        <label for="address">Para Birimi</label>
                        <select class="form-control" id="currency" *ngIf="!isReadonly" [(ngModel)]="data.currencyId">
                          <option *ngFor="let item of currencies" [value]="item.id"
                            [selected]="data.currencyId == item.id">
                            {{item.currencyName}}</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-xl-12 col-md-6 col-12">
                      <div class="form-group">
                        <label for="labels">Etiketler</label>
                        <div class="chip-container">
                          <div *ngFor="let label of data.label" class="badge badge-pill badge-danger"
                            style="margin-right: 5px;">
                            {{ label.labelName }}
                            <button type="button" class="close" aria-label="Close" (click)="removeLabel(label.labelId)">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                        </div>
                        <textarea class="form-control" id="labelTextarea" rows="1" placeholder="Etiket Giriniz."
                          [(ngModel)]="newLabel" (keydown.enter)="addLabel($event)">
                        </textarea>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex align-items-center justify-content-between">

                    <div class="d-flex align-items-center ml-auto">
                      <div class="text-body align-middle">Oluşturulma Tarihi: {{data?.createdAt | date:'dd.MM.yyyy'}}
                      </div>
                    </div>
                  </div>
                  <div class="d-flex mt-2" *ngIf="!isReadonly">
                    <!-- Sil button (left-aligned) -->
                    <div class="custom-control custom-switch custom-switch-success justify-content-start"
                      *ngIf="data!.id != 1 && data!.id != 2">
                      <button type="button" class="btn btn-danger" appDelete controller="companies" [id]="data.id"
                        (callback)="confirmedRemove()">
                        Sil
                      </button>
                    </div>

                    <!-- Spacer to push remaining buttons to the right -->
                    <div class="ml-auto d-flex">

                      <!-- İptal button (right-aligned) -->
                      <div class="custom-control custom-switch custom-switch-success" *ngIf="!isReadonly">
                        <button type="button" class="btn btn-warning" (click)="toggleReadonly()">
                          İptal
                        </button>
                      </div>

                      <!-- Kaydet button (right-aligned) -->
                      <button class="btn btn-success ml-1" rippleEffect (click)="saveData()">
                        <i data-feather="edit" class="d-sm-none d-inline-block mr-0 mr-sm-1"></i>
                        <span class="d-none d-sm-inline-block">Kaydet</span>
                      </button>

                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div class="p-75 row d-flex justify-content-between">
            <div class="card text-center col-xl-2 col-md-4 col-sm-6">
              <div class="card-body">
                <div
                  [ngClass]="(data?.priceVault + data?.transactionPrice) >= 0 ? 'bg-light-success' : 'bg-light-danger'"
                  class="avatar p-50 m-0 mb-1">
                  <div class="avatar-content">
                    <i data-feather="dollar-sign" class="font-medium-5"></i>
                  </div>
                </div>
                <h2 class="font-weight-bolder">{{data?.priceVault + data?.transactionPrice | number:'1.2-2'}}</h2>
                ({{data.currencyName}})
                <p class="mb-0 line-ellipsis">{{data?.priceVault + data?.transactionPrice >= 0 ? "Alacaklı" : "Borçlu"}}
                </p>
              </div>
            </div>

            <div class="card text-center col-xl-2 col-md-4 col-sm-6">
              <div class="card-body">
                <div class="avatar bg-light-info p-50 m-0 mb-1">
                  <div class="avatar-content">
                    <i data-feather="shopping-bag" class="font-medium-5"></i>
                  </div>
                </div>
                <h2 class="font-weight-bolder">{{data?.salesCount}}</h2>
                <p class="mb-0 line-ellipsis">Toplam Satış</p>
              </div>
            </div>

            <div class="card text-center col-xl-2 col-md-4 col-sm-6 ">
              <div class="card-body">
                <div class="avatar bg-light-warning p-50 m-0 mb-1">
                  <div class="avatar-content">
                    <i data-feather="shopping-cart" class="font-medium-5"></i>
                  </div>
                </div>
                <h2 class="font-weight-bolder">{{data?.buyingCount}}</h2>
                <p class="mb-0 line-ellipsis">Toplam Alış</p>
              </div>
            </div>

            <div class="card text-center col-xl-2 col-md-4 col-sm-6 ">
              <div class="card-body">
                <div class="avatar bg-light-danger bg-darken-2 p-50 m-0 mb-1">
                  <div class="avatar-content">
                    <i data-feather="file-text" class="font-medium-5"></i>
                  </div>
                </div>
                <h2 class="font-weight-bolder">{{data?.offerCount}}</h2>
                <p class="mb-0 line-ellipsis">Toplam Teklif</p>
              </div>
            </div>

            <div class="card text-center col-xl-2 col-md-4 col-sm-6 ">
              <div class="card-body">
                <div class="avatar bg-light-danger bg-darken-2 p-50 m-0 mb-1">
                  <div class="avatar-content">
                    <i data-feather="file-text" class="font-medium-5"></i>
                  </div>
                </div>
                <h2 class="font-weight-bolder">{{data?.requestTaskCount}} / {{data?.actionCount}}</h2>
                <p class="mb-0 line-ellipsis">Toplam Talep / Aksiyon</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul ngbNav #nav="ngbNav" class="nav-tabs">
        <li ngbNavItem>
          <a ngbNavLink>İlgili Kişiler</a>
          <ng-template ngbNavContent>
            <div class="card">

              <div class="card-body table-responsive">
                <h3>Firma Personelleri</h3>
                <app-company-detail-person-list *ngIf="data != null"></app-company-detail-person-list>
              </div>
            </div>
          </ng-template>
        </li>
        <li ngbNavItem *ngIf="data.id != 1">
          <a ngbNavLink>Talepler ve Aksiyonlar</a>
          <ng-template ngbNavContent>
            <div class="card">
              <div class="card-body table-responsive">
                <h3>Firma Talepleri ve Aksiyonları</h3>
                <app-company-detail-request-task-list></app-company-detail-request-task-list>
              </div>
            </div>
          </ng-template>
        </li>
        <li ngbNavItem *ngIf="data.id != 1">
          <a ngbNavLink>İşlemler</a>
          <ng-template ngbNavContent>
            <div class="card ">
              <app-company-detail-transaction-list></app-company-detail-transaction-list>
            </div>
          </ng-template>
        </li>
        <li ngbNavItem>
          <a ngbNavLink>Cihazlar</a>
          <ng-template ngbNavContent>
            <div class="card ">
              <app-company-detail-device-list></app-company-detail-device-list>
            </div>
          </ng-template>
        </li>
        <li ngbNavItem>
          <a ngbNavLink>Dosyalar</a>
          <ng-template ngbNavContent>
            <h3 class="ml-1 mt-1">Firma Dosyalar</h3>
            <app-fileupload [options]="options" style="width: 40%; margin: 15px;"></app-fileupload>
            <div class="row">
              <div class="col-md-6 col-lg-4" *ngFor="let image of files">
                <div class="card">
                  <img class="card-img-top" [src]="image.path" alt="Card image cap" height="300px" width="300px" />
                  <div class="card-body">
                    <div class="d-flex justify-content-between">
                      <h4 class="card-title">{{ image.fileName }}</h4>
                      <button type="button" class="btn btn-icon btn-flat-success" rippleEffect
                        (click)="removeCompanyFile(image.id,data.id)">
                        <span [data-feather]="'trash'"></span></button>
                    </div>
                    <div class="custom-control custom-radio">
                      <input type="radio" id="customRadio{{image.id}}" name="customRadio" class="custom-control-input"
                        [(ngModel)]="selectedImageId" [value]="image.id" (change)="onRadioChange(image.id)" selected />
                      <label class="custom-control-label" for="customRadio{{image.id}}">Seçili Logo</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </li>
        <li ngbNavItem>
          <a ngbNavLink>Hesap Hareketleri</a>
          <ng-template ngbNavContent>
            <div class="card">
              <div class="card-body table-responsive">
                <h3>Hareketler</h3>
                <app-company-detail-vault-movements></app-company-detail-vault-movements>
              </div>
            </div>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav" class="mt-2"></div>
    </div>
  </div>